import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import Layout from "./Pages/Layout";
import Home from "./Pages/Home";
import Profile from "./Pages/Profile";
import Maintenance from "./Pages/Maintenance";
import Error404 from "./Pages/error/404";
import Bonus from "./Pages/quiz/Bonus";
import BonusResult from "./Pages/quiz/BonusResult";
import Join from "./Pages/quiz/join";
import QuizGame from "./Pages/quiz/start";
import QuizResult from "./Pages/quiz/result";
import Search from "./Pages/quiz/Search";
import Rules from "./Pages/Rules";
import CoinHistory from "./Pages/CoinHistory";
import FramePage from "./Pages/FramePage";
import SEO from "./components/SEO";

function App() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  const location = useLocation();
  const hasCheckedRedirect = useRef(false);

  /**
   * Create guest user if not exists
   */
  useEffect(() => {
    if (!user) {
      const guestUser = {
        id: Date.now(),
        name: "Guest",
        coins: 0,
        is_guest: true,
        first_visit: 1,
      };
      dispatch({ type: "SET_USER", payload: guestUser });
    }
  }, [user, dispatch]);

  /**
   * First visit bonus redirect logic
   */
  useEffect(() => {
    // Only run once
    if (hasCheckedRedirect.current) return;
    
    // Wait for user to be loaded
    if (!user) return;
    
    // Mark as checked
    hasCheckedRedirect.current = true;
    
    // Use a small delay to ensure React Router has processed the route
    setTimeout(() => {
      const currentPath = location.pathname;
      const SKIP_BONUS_ROUTES = ["/frame", "/maintenance"];

      // Check if current path should skip bonus redirect
      const shouldSkip = SKIP_BONUS_ROUTES.some(route => currentPath.startsWith(route));

      // Only redirect if first visit and not on a skip route or bonus route
      if (
        user.first_visit === 1 &&
        !currentPath.startsWith("/quiz/bonus") &&
        !shouldSkip
      ) {
        navigate("/quiz/bonus", { replace: true });
      }
    }, 0);
  }, [user, navigate, location.pathname]);

  return (
    <>
      <SEO />
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="profile" element={<Profile />} />
          <Route path="rules" element={<Rules />} />
          <Route path="coin-history" element={<CoinHistory />} />
          <Route path="quiz/search" element={<Search />} />
          <Route path="quiz/join/:id" element={<Join />} />
          <Route path="join-contest/:id" element={<Join />} />
          <Route path="quiz/start/:id" element={<QuizGame />} />
          <Route path="quiz/result/:id" element={<QuizResult />} />
          <Route path="quiz/bonus" element={<Bonus />} />
          <Route path="quiz/bonus/result" element={<BonusResult />} />
          <Route path="*" element={<Error404 />} />
        </Route>
        <Route path="/frame" element={<FramePage />} />
        <Route path="/maintenance" element={<Maintenance />} />
      </Routes>
    </>
  );
}

export default App;